import {useMapContext} from "../../contexts/MapContext"

import Datetime from 'react-datetime';
import { useAdminContext } from "@/contexts/AdminContext";

import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import ComboBoxBoatCode from "./ComboBoxBoatCode";

import 'moment-timezone';
import moment from 'moment';




export default function MapFilter() {
    const {errorDateMessage, momentToday, minDate, maxDate, setDateDeb, setDateFin, dateDeb, dateFin, selectedBoatCodes, setSelectedBoatCodes, uniqueBoats} = useMapContext();
    const {tabIdBoats, colorMapCache, loading} = useAdminContext();


    const makeLine = (code: string) => {
        return <svg height="10px" width="30px" xmlns="http://www.w3.org/2000/svg">
                    <line x1="0" y1="0" x2="60" y2="0" style={{stroke: colorMapCache[code] ,strokeWidth:"7"}} />
                </svg>
    };
    
   const handleDateDeb = (event: any) => {
    setDateDeb(new Date(event))
    console.log("ok debut")
   };

   const handleDateFin = (event: any) => {
    setDateFin(new Date(event))
    console.log("ok fin")
   };

   const isValidMinDate = (current: moment.Moment) => {
        if (current.isAfter(momentToday, "day")) return false;
        if (!current.isSameOrAfter(minDate, "day")) return false;
        return true;
    };

    const isValidMaxDate = (current: moment.Moment) => {
        if (current.isAfter(momentToday, "day")) return false;
        if (!current.isSameOrBefore(maxDate, "day")) return false;
        return true;
   };


   const handleReset = () => {
       setSelectedBoatCodes([]);
    };

   const handleSelectedBoat = (name: string) => {
      //setSelectedBoatCodes(name);
   };

   const styleErrorMessage = {color: "orange"};


  return <Card className="filter-container">
            <Card.Body>
                <strong>Filtre bateaux</strong>
                <div>
                    <ComboBoxBoatCode {...{setSelectedBoatCodes}}></ComboBoxBoatCode>
                </div>
                <strong>Temporalité</strong>
                <br></br>
                du
                <Datetime 
                    displayTimeZone="Pacific/Tahiti" 
                    initialValue={dateDeb} 
                    onChange={handleDateDeb}
                    isValidDate={isValidMinDate}/>
                au
                <Datetime 
                    displayTimeZone="Pacific/Tahiti"
                    initialValue={dateFin} 
                    onChange={handleDateFin}
                    isValidDate={isValidMaxDate}/>

                {errorDateMessage != "" ? (
                    <p style={styleErrorMessage}> {errorDateMessage}</p>
                ) : null}

                <br></br>
                <br></br>
                {uniqueBoats?.length} Bateaux sortis durant cette période
                <ListGroup className="scrollable-bateaux">
                    {uniqueBoats?.length ? (
                                uniqueBoats.sort().map((boatId:string) => (
                                <ListGroup.Item className="d-flex justify-content-between align-items-center">
                                    {tabIdBoats[boatId]?.code} {makeLine(tabIdBoats[boatId]?.code)}
                                </ListGroup.Item>
                                ))
                                ) : null
                    }
                </ListGroup>
                
                {loading ? 
                    <div className="loader-wrapper">
                        <div className="loader"></div>
                            <p>Subscription en cours...</p>
                    </div> : null}
            </Card.Body>
        </Card>
}
